module.exports = __webpack_public_path__ + "img/ug339.9e5ed172.png";